import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { models, utils } from '@tfo/common'
import { observer } from 'mobx-react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useStore } from '../../../hooks/useStore'
import $http from '../../../utils/$http'

export const SelectOrderRecipients = observer(
	({ onSelect, companyId, error, defaultId }: { onSelect: (newValue: any) => void, companyId: number, error?: boolean, defaultId?: number }) => {
		const intl = useIntl()
		const { clientViewStore, network, userStore } = useStore()
		const [users, setUsers] = React.useState([])
		const [selectedValue, setSelectedValue] = React.useState()
		const [companyDictionary, setCompanyDictionary] = React.useState({})

		React.useEffect(() => {
			if (companyId) {
				getCompanyNames()
			}
		}, [companyId])

		const getCompanyNames = async () => {
			const companyDict = {}
			const companies = await $http.get<any>(`/company/${companyId}/ancestor?includingSelf=true`)
			if (companies) {
				companies.map((company: models.ICompany) => {
					companyDict[company.id] = company.name
				})
				setCompanyDictionary(companyDict)
			}
			getUsers(companyDict)
		}

		const getUsers = async companyDict => {
			const companyUsers = await $http.get<any>(`/user/customer/connected/${companyId}`)

			companyUsers.map(
				(user: any) => (user.label = `${user.firstName} ${user.lastName}`),
			)

			//sort first on company name then on user name
			companyUsers.sort((a, b) => {
				const { label: labelA, companyId: companyIdA } = a
				const { label: labelB, companyId: companyIdB } = b

				if (companyDict[companyIdA] < companyDict[companyIdB]) return -1
				if (companyDict[companyIdA] > companyDict[companyIdB]) return 1
				if (labelA < labelB) return -1
				if (labelA > labelB) return 1
				return 0
			})
			const filteredUsers = filterUsers(companyUsers)
			clientViewStore.companyHasUsersToShareReportWith = filteredUsers.length > 0
			setUsers(filteredUsers)
		}

		const filterUsers = (companyUsers) => {
			return companyUsers.filter(u => u.isActive === true && u.id !== userStore.user.id && !utils.isOrderer(u))
		}

		return (
			<>
				{users?.length > 0 &&
					<Autocomplete
						className={error ? 'TextInput__Input--hasError' : ''}
						style={error ? { border: '1px solid #D10074', borderRadius: '4px' } : {}}
						options={users}
						defaultValue={defaultId ? users.find(x => x.id === defaultId) : ''}
						onChange={(_, newValue) => {
							setSelectedValue(newValue)
							onSelect(newValue)
						}}
						groupBy={option => companyDictionary[option.companyId]}
						getOptionLabel={option => `${option.firstName} ${option.lastName}`}
						noOptionsText={'No options'}
						renderInput={params => (
							<TextField
								{...params}
								label={intl.formatMessage({ id: 'common.user' })}
								variant="outlined"
								fullWidth
							/>
						)}
					/>
				}
			</>
		)
	},
)

export default SelectOrderRecipients
